import { render, staticRenderFns } from "./BrickSettingsPopup.vue?vue&type=template&id=321f51c6&"
import script from "./BrickSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321f51c6')) {
      api.createRecord('321f51c6', component.options)
    } else {
      api.reload('321f51c6', component.options)
    }
    module.hot.accept("./BrickSettingsPopup.vue?vue&type=template&id=321f51c6&", function () {
      api.rerender('321f51c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/BrickSettingsPopup.vue"
export default component.exports